import { render, staticRenderFns } from "./Tabulator.vue?vue&type=template&id=0f9bd218&scoped=true&"
import script from "./Tabulator.vue?vue&type=script&lang=js&"
export * from "./Tabulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bd218",
  null
  
)

export default component.exports